import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { MessageSquareIcon, PenToolIcon, CodeIcon, RocketIcon } from 'lucide-react';
export function ProcessSection() {
  const revealRef = useScrollReveal();
  const steps = [{
    num: '01',
    title: 'Konzultácia',
    desc: 'Pochopíme váš biznis a identifikujeme príležitosti pre AI.',
    icon: <MessageSquareIcon className="w-6 h-6" data-id="element-435" />,
    color: 'text-blue-500',
    bg: 'bg-blue-50',
    glow: 'shadow-blue-100'
  }, {
    num: '02',
    title: 'Návrh',
    desc: 'Navrhneme architektúru a UX pre maximálnu konverziu.',
    icon: <PenToolIcon className="w-6 h-6" data-id="element-436" />,
    color: 'text-purple-500',
    bg: 'bg-purple-50',
    glow: 'shadow-purple-100'
  }, {
    num: '03',
    title: 'Vývoj',
    desc: 'V 14-dňových šprintoch dodávame reálne fungujúce časti.',
    icon: <CodeIcon className="w-6 h-6" data-id="element-437" />,
    color: 'text-emerald-500',
    bg: 'bg-emerald-50',
    glow: 'shadow-emerald-100'
  }, {
    num: '04',
    title: 'Launch',
    desc: 'Nasadenie, testovanie a škálovanie vašej novej PWA.',
    icon: <RocketIcon className="w-6 h-6" data-id="element-438" />,
    color: 'text-amber-500',
    bg: 'bg-amber-50',
    glow: 'shadow-amber-100'
  }];
  return <section ref={revealRef} className="py-36 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto overflow-hidden" data-id="element-439">
      <div className="reveal text-center mb-28" data-id="element-440">
        <p className="text-xs font-semibold tracking-[0.2em] text-apple-gray uppercase mb-6" data-id="element-441">
          NÁŠ PROCES
        </p>
        <h2 className="text-4xl md:text-6xl font-extrabold tracking-tight text-apple-black mb-6" data-id="element-442">
          Ako Spolupracujeme
        </h2>
        <p className="text-xl text-apple-gray font-light max-w-2xl mx-auto leading-relaxed" data-id="element-443">
          Náš proces je navrhnutý pre rýchlosť a kvalitu. Od prvého stretnutia
          po nasadenie do produkcie.
        </p>
      </div>

      <div className="relative" data-id="element-444">
        {/* Connecting Line (Desktop) — gradient */}
        <div className="hidden md:block absolute top-12 left-[12%] right-[12%] h-[2px] bg-gradient-to-r from-blue-200 via-purple-200 via-emerald-200 to-amber-200 z-0 rounded-full" data-id="element-445" />
        {/* Connecting Line (Mobile) */}
        <div className="md:hidden absolute top-0 bottom-0 left-8 w-[2px] bg-gradient-to-b from-blue-200 via-purple-200 via-emerald-200 to-amber-200 z-0 rounded-full" data-id="element-446" />

        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8 relative z-10" data-id="element-447">
          {steps.map((step, index) => <div key={index} className={`reveal reveal-delay-${index + 1} flex flex-row md:flex-col items-start md:items-center gap-6 md:gap-0`} data-id="element-448">
              <div className={`flex-shrink-0 w-16 h-16 ${step.bg} rounded-full shadow-lg ${step.glow} flex items-center justify-center md:mb-8 relative z-10 border border-white/80`} data-id="element-449">
                <div className={step.color} data-id="element-450">{step.icon}</div>
              </div>
              <div className="flex flex-col md:items-center md:text-center pt-2 md:pt-0" data-id="element-451">
                <span className={`text-xs font-bold ${step.color} mb-2 tracking-[0.2em]`} data-id="element-452">
                  {step.num}
                </span>
                <h3 className="text-xl font-bold text-apple-black mb-3" data-id="element-453">
                  {step.title}
                </h3>
                <p className="text-apple-gray font-light leading-relaxed text-sm" data-id="element-454">
                  {step.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}